import * as angular from "angular";
import {IController} from "angular";

export class BringozTabsCtrl implements IController {

  tabs: any;
  showValues: any;
  selected: any;
  onSelect: Function;

  private selectedIndex: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {

  }

  $onChanges(changes) {
    if (changes.selected) {
      this.selectedIndex = this.selected || 0;
    }
  }

  selectTab(index) {
    this.selectedIndex = index;
    if (this.onSelect)
      this.onSelect(index);
    if (this.tabs[index].onClick)
      this.tabs[index].onClick();
  };

}

angular
  .module('bringoz.admin.commons')
  .component('bringozTabs', {
    bindings: {
      tabs: '<',
      showValues: '<?',
      selected: '<?',
      onSelect: '&'
    },
    template: require('./bringoz-tabs.html').default,
    controller: BringozTabsCtrl
  });
